import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// data
import { trackHeaderPromoCtaClicked } from "core/trackEvent.js";

// components
import Button from "core/Button";
import Heading from "core/Heading";
import BodyText from "core/BodyText";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { bold } from "core/fontStyles";

const ContentStyled = styled.div`
    padding: 0rem ${convertPxToRem(24)} ${convertPxToRem(24)};
    display: flex;
    gap: ${convertPxToRem(24)};
`;

const ImageWrapperStyled = styled.div`
    flex: 0 0 ${convertPxToRem(230)};
    img {
        max-width: 100%;
        display: block;
    }
`;
const TextWrapperStyled = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
const ButtonWrapperStyled = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const HeadingStyled = styled(Heading).attrs({
    type: "h2",
    size: "sm"
})`
    ${bold}
    margin-bottom: ${convertPxToRem(16)};
`;

const BodyTextStyled = styled(BodyText).attrs({
    type: "p",
    size: "md"
})`
    margin-bottom: ${convertPxToRem(24)};
`;

// component
export const Content = ({ userMessage }) => {
    const {
        modalHeadline,
        modalImageUrl,
        ctaUrl,
        ctaText,
        ctaTarget,
        modalMessage
    } = userMessage;

    return (
        <ContentStyled>
            {modalImageUrl && (
                <ImageWrapperStyled className="image">
                    <img
                        data-testid="modal-content-image"
                        alt={modalHeadline}
                        src={modalImageUrl}
                    />
                </ImageWrapperStyled>
            )}
            <TextWrapperStyled>
                <div>
                    <HeadingStyled>{modalHeadline}</HeadingStyled>
                    <BodyTextStyled>{modalMessage}</BodyTextStyled>
                </div>
                <ButtonWrapperStyled>
                    <Button
                        href={ctaUrl}
                        target={ctaTarget}
                        onMouseDown={trackHeaderPromoCtaClicked}
                    >
                        {ctaText}
                    </Button>
                </ButtonWrapperStyled>
            </TextWrapperStyled>
        </ContentStyled>
    );
};

export default Content;

// prop-types
Content.propTypes = {
    userMessage: PropTypes.object.isRequired
};
